import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import './ImageModal.css'; // Import your custom styles for the modal

const ImageModal = ({ src, alt, onClose }) => {
  return (
    <Box
      className="image-modal-overlay"
      onClick={onClose}
    >
      <Box
        className="image-modal-content"
        onClick={(e) => e.stopPropagation()} // Prevent modal close when clicking inside the image
      >
        <img src={src} alt={alt} className="image-modal-image" />
      </Box>
    </Box>
  );
};

ImageModal.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ImageModal;
